export default __webpack_public_path__ + "static/media/img4.1017b924.jpg";